export enum RoleEnum {
  SUPER_ADMIN = 'Super Admin',
  SALES_ADMIN = 'Sales Admin',
  SALES_PERSON = 'Sales Person',
  OPERATIONS_MANAGER = 'Operations Manager',
  WAREHOUSE_LEAD = 'Warehouse Lead',
  WAREHOUSE_STAFF = 'Warehouse Staff',
  FOREMAN = 'Foreman',
  CREW = 'Crew',
  DRIVER = 'Driver',
  LOADER = 'Loader',
}

export enum SignInTypeEnum {
  STANDARD = 'STANDARD',
}

export enum MessageTypeEnum {
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  PHOTO = 'PHOTO',
  AUDIO = 'AUDIO',
  FILE = 'FILE',
  EMOTION = 'EMOTION',
  LOCATION = 'LOCATION',
}

export enum MenuNameEnum {
  DASHBOARD = 'menu_dashboard',
  JOBS = 'menu_jobs',
  CRM = 'menu_crm',
  COMMUNICATION = 'menu_communication',
  QUOTES = 'menu_quotes',
  SETTINGS = 'menu_settings',
  USER = 'menu_users',
  LEADS = 'menu_leads',
  CLIENT = 'menu_clients',
  INVENTORY = 'menu_inventory',
  PRODUCT = 'menu_product',
  PACKAGE = 'menu_package',
  SCHEDULE = 'menu_schedule',
  VEHICLES = 'menu_vehicle',
  TASKS = 'menu_tasks',
  TRUCKS = 'menu_truck',
  EQUIPMENTS = 'menu_equipment',
  TRAILERS = 'menu_trailer',
  VENDORS = 'menu_vendors',
  INVOICE = 'menu_invoice',
  REPORTS = 'menu_reports',
  PURCHASE_ORDER = 'menu_purchase_order',
  ORDER = 'menu_order_management',
  QUARANTINE = 'menu_quarantine',
}

export enum CommunicationTabEnum {
  PHONE_CALLS = 'phone_calls',
  TEXT_MESSAGES = 'text_messages',
}

export enum UserTabEnum {
  INFORMATION = 'information',
  CHANGE_PASSWORD = 'change_password',
}

export enum InventoryTabEnum {
  PRODUCT_DETAIL = 'product_detail',
  ACTIVITY_LOG = 'activity_log',
  PRODUCT_AVAILABILITY = 'product_availability',
}

export enum QuoteTabEnum {
  INFORMATION = 'information',
  OVERBOOKED_ITEMS = 'overbooked_items',
  DOCUMENTS = 'document',
}

export enum OrderTabEnum {
  INFORMATION = 'information',
  INVOICE = 'invoice',
  OVERBOOKING = 'overbooking',
  DOCUMENTS = 'documents',
  CALL_HISTORY = 'call_history',
  COSTING = 'costing',
}

export enum JobTabEnum {
  INFORMATION = 'information',
  TASKS = 'tasks',
  CHECKLIST = 'checklist',
  INCIDENTS = 'incidents',
  ACTIVITY = 'activity',
  COSTING = 'costing',
  NOTES = 'notes',
  INTERNAL_NOTES = 'internal_notes',
  EXTERNAL_NOTES = 'external_notes',
  SITE_NOTES = 'site_notes',
}

export enum ClientTabEnum {
  DETAILS = 'details',
  CONTACTS = 'contacts',
  ORDERS = 'orders',
  APPOINTMENTS = 'appointments',
  TASKS = 'tasks',
  DOCUMENTS = 'documents',
  INVOICE = 'invoice',
  CONST = 'const',
  HISTORY = 'history',
}

export enum VendorTabEnum {
  DETAILS = 'details',
  PURCHASE_ORDER = 'purchase_orders',
  SUBRENTALS = 'subrentals',
}

export enum StatusEventEnum {
  SENT = 'SENT',
  CONVERTED = 'CONVERTED',
}

export enum MessageStatusEnum {
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  SEEN = 'SEEN',
}

export enum ItemScheduleTypeEnum {
  ISSUE = 'issue',
  TENTS = 'tent',
  FURNITURE = 'furniture',
  CUSTOM = 'custom',
  CUSTOMER_HANDOFF = 'customer handoff',
}

export enum DateFormatEnum {
  YYYYMMDD_HHmmss = 'YYYYMMDD_HHmmss',
  MM_DD_YYY_HH_MM_SS = 'MM/DD/YYYY, hh:mm:ss',
  MM_DD_YYYY_H_mm_A = 'MM/DD/YYYY, h:mm A',
  YYYY_MM_DD = 'YYYY-MM-DD',
  M_DD_YYYY = 'M/DD/YYYY',
  MM_DD_YYYY = 'MM/DD/YYYY',
  D_M_YYYY = 'D/M/YYYY',
  M_D_YYYY = 'M/D/YYYY',
  MMMM_YYYY = 'MMMM YYYY',
  MMM_D_YYYY = 'MMM D, YYYY',
  MMM_D = 'MMM D',
  HH_mm_A = 'hh:mm A',
  HH_mm = 'hh:mm',
  MM_DD = 'MM/DD',
  HH_MM_SS = 'hh:mm:ss',
  YYYY = 'YYYY',
  YYYY_MM = 'YYYY-MM',
  DD_MMM = 'DD MMM',
}

export enum ReportTypeEnum {
  OVERBOOKING_ITEM = 'overbooking item',
  SUB_RENTAL = 'sub rental',
  QUARANTINE = 'quarantine',
  CLIENT_INCOME = 'client income',
  REVENUE_WEEK = 'revenue week',
  REVENUE_MONTH = 'revenue month',
  GEOGRAPHIC_REVENUE = 'geographic revenue',
  QUOTE_REVENUE = 'quote revenue',
  ORDER_REVENUE = 'order revenue',
  CANCELLATION = 'cancellation',
  DELIVERY_PICKUP = 'delivery pickup',
  USER_TASK = 'user task',
  FOREMAN_TASK_COMPLETION = 'foreman task completion',
  FUTURE_UTILIZATION = 'future utilization',
  MARKETING_REVENUE = 'marketing revenue',
  DISCOUNT_USAGE = 'discount usage',
  JOB_COSTING = 'job costing',
  FINANCIAL_ORDER = 'financial order',
  TRANSACTION_SUMMARY = 'transaction summary',
}

export enum PlaceAddressEnum {
  LOCALITY = 'locality',
  STATE = 'administrative_area_level_1',
  ZIP_CODE = 'postal_code',
  COUNTRY = 'country',
  UNIT = 'subpremise',
}

export enum StatusEnum {
  DRAFT = 'draft',
  ORDER = 'order',
  QUOTE = 'quote',
  PARTIAL = 'partial',
  OVERDUE = 'overdue',
  CANCELED = 'canceled',
  NOT_PAID = 'not paid',
  PAID = 'paid',
  PARTIALLY_PAID = 'partially paid',
  ALL = 'all',
  SCHEDULED = 'SCHEDULED',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  HIGH = 'HIGH',
  HIGH_LOWER = 'high',
  HIGH_CASE = 'High',
  LOW = 'low',
  MEDIUM = 'medium',
  PENDING = 'PENDING',
  IN_PROCESS = 'in process',
  PENDING_APPROVAL = 'pending approval',
  COMPLETED = 'completed',
  QUOTE_EXPIRED = 'quote expired',
  QUOTE_CANCELLED = 'quote cancelled',
  UNAVAILABLE = 'unavailable',
  DAMAGED = 'Damage',
  INSTITUTIONAL = 'institutional',
  IN_PROGRESS = 'in progress',
  PENDING_LOWER = 'pending',
  SCHEDULED_LOWER = 'scheduled',
  OVERBOOKING = 'overbooking',
  QUOTE_OPEN = 'Open',
  PO_OPEN = 'open',
  PO_CANCEL = 'cancelled',
  PO_APPROVED = 'approved',
  PO_PENDING_DELIVERY = 'pending delivery',
  PO_RECEIVED = 'received',
  PO_CLOSED = 'closed',
  MAINTENANCE = 'Maintenance',
  ORDER_HOLD = 'hold',
  LEAD = 'lead',
  CLIENT = 'client',
  ASSIGNED = 'assigned',
  UNASSIGNED = 'unassigned',
  DELIVERY = 'delivery',
  PICKUP = 'pickup',
}

export enum TagEnum {
  DELIVERY = 'Delivery',
  PICK_UP = 'Pick Up',
}

export enum ChipColorEnum {
  DEFAULT = 'default',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum PageEnum {
  KANBAN = 'KANBAN',
  LIST = 'LIST',
}

export enum SortTypeEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum FileTypeEnum {
  DOC = 'doc',
  DOCX = 'docx',
  PDF = 'pdf',
  XLSX = 'xlsx',
  XLS = 'xls',
}

export enum DiscountTypeEnum {
  PERCENTAGE = 'percentage',
  AMOUNT = 'amount',
}

export enum ClipboardDataEnum {
  TEXT = 'text',
}

export enum KeyboardEnum {
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  DELETE = 'Delete',
  SPACE = ' ',
  BACKSPACE = 'Backspace',
  TAB = 'Tab',
  ENTER = 'Enter',
}

export enum HeaderEnum {
  TIME_ZONE = 'time-zone',
}

export enum ToastTypeEnum {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

export enum VerifyTypeEnum {
  FORGOT_PASSWORD = 'forgot password',
}

export enum AcceptFileEnum {
  EXCEL = '.xlsx, .xls',
  XLSX = '.xlsx',
  XLS = '.xls',
  CSV = '.csv',
}

export enum PaymentMethodEnum {
  CASH = 'Cash',
  CHECK = 'Check',
  CARD = 'Card',
}

export enum TypeErrorFormEnum {
  MANUAL = 'manual',
}

export enum ModeTextEditorEnum {
  VIEW = 'view',
  CREATE = 'create',
  EDIT = 'edit',
}

export enum ThemeTextEditorEnum {
  SNOW = 'snow',
  BUBBLE = 'bubble',
}

export enum ReasonType {
  UPDATED_COUNT = 'updated count',
  PURCHASED_NEW_PRODUCT = 'purchased new product',
}

export enum LoadingSizeEnum {
  SMALL = 16,
  MEDIUM = 24,
  LARGE = 32,
}

export enum ActivityTypeEnum {
  CREATE_INVENTORY = 'create inventory',
  UPDATE_INVENTORY = 'update inventory',
  DELETE_INVENTORY = 'delete inventory',
}

export enum BusinessModelEnum {
  INVENTORY = 'inventory',
}

export enum BusinessTypeEnum {
  INVENTORY = 'inventory',
  CLIENT = 'client',
  JOB = 'job',
  QUOTE = 'quote',
  ORDER = 'order',
}

export enum TypeDetailClientEnum {
  OVERVIEW = 'overview',
  QUOTES = 'quotes',
  APPOINTMENTS = 'appointments',
  TASKS = 'tasks',
  DOCUMENTS = 'documents',
  INVOICE = 'invoice',
  COST = 'cost',
  ACTIVITY = 'activity',
  HISTORY = 'history',
  ADDITIONAL_CONTACT = 'additional contact',
}

export enum TypeMasterDataListEnum {
  TAG_TASK = 'tag task',
  QUOTE_EVENT = 'quote event',
  EVENT = 'event',
}

export enum TypeInventoryGroupDay {
  ORDER = 'order',
  QUOTE = 'quote',
  ALL = 'all',
  DEFAULT = 'default',
}

export enum TypeQuoteDetailEnum {
  OVERVIEW = 'overview',
  DOCUMENTS = 'documents',
  OVERBOOKED_ITEMS = 'overbooked items',
}

export enum TypeOrderDetailEnum {
  OVERVIEW = 'overview',
  INVOICE = 'invoice',
  DOCUMENTS = 'documents',
  OVERBOOKED_ITEMS = 'overbooked items',
}

export enum TypeJobDetailEnum {
  OVERVIEW = 'overview',
  TASKS = 'tasks',
  CHECKLIST = 'checklist',
  INCIDENTS = 'incidents',
  ACTIVITY = 'activity',
  COSTING = 'job costing',
  NOTES = 'notes',
}

export enum TypeListInventory {
  PRODUCT = 'product',
  PACKAGE = 'package',
  PART = 'part',
}

export enum TypeVendorDetailEnum {
  OVERVIEW = 'overview',
  PURCHASE_ORDER = 'purchase order',
  SUB_RENTAL = 'sub rental',
}

export enum TypeCrmEnum {
  LEAD = 'lead',
  CLIENT = 'client',
}

export enum TypeDetailInventoryEnum {
  OVERVIEW = 'overview',
  ACTIVITY = 'activity',
  PRODUCT_AVAILABILITY = 'product availability',
}

export enum ProductDesignationEnum {
  UNASSIGNED = 'unassigned',
  FURNITURE = 'furniture',
  TENTS = 'tent',
  CUSTOM = 'custom',
}

export enum DepositMadeEnum {
  NOT_REQUIRED = 'not required',
  RENTAL_ORDER_DEPOSIT = 'rental order deposit',
  WASHING_ORDER_DEPOSIT = 'washing order deposit',
}

export enum PurchaseOrderEnum {
  PURCHASE = 'purchase',
  SUB_RENTAL = 'sub rental',
}

export enum QuoteStatusEnum {
  QUOTE_REQUEST = 'quote request',
  IN_PROCESS = 'in process',
  COMPLETED = 'completed',
  PENDING_APPROVAL = 'pending approval',
  QUOTE_EXPIRED = 'quote expired',
  QUOTE_CANCELLED = 'quote cancelled',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

export enum OrderStatusEnum {
  HOLD = 'hold',
  PENDING = 'pending',
  BOOKED = 'booked',
  FINALIZED = 'finalized',
  NOT_FINALIZED = 'not finalized',
  RENTED_OUT = 'rented out',
  RETURNED = 'returned',
}

export enum ConnectionStatusEnum {
  CONNECTED = 'connected',
  CONNECTING = 'connecting',
  DISCONNECTED = 'disconnected',
}

export enum ReportItemEnum {
  INVENTORY_USAGE = 'inventory_usage',
  OVERBOOKING_ITEMS = 'overbooking_items',
  SUBRENTALS = 'subrentals',
  QUARANTINE = 'quarantine',

  CLIENT_INCOME = 'client_income',
  REVENUE = 'revenue',
  GEOGRAPHIC_REVENUE = 'geographic_revenue',
  QUOTE_REVENUE = 'quote_revenue',

  ORDER_REVENUE = 'order_revenue',
  CANCELLATIONS = 'cancellations',
  SCHEDULE = 'schedule',
  DELIVERY_PICKUP = 'delivery_pickup',

  FOREMAN_TASKS = 'foreman_tasks',
  FOREMAN_TASK_COMPLETION = 'foreman_task_completion',
  FUTURE_UTILIZATION = 'future_utilization',
  MARKETING_REVENUE = 'marketing_revenue',

  USER_TASKS = 'user_tasks',
  DISCOUNT_USAGE = 'discount_usage',
  JOB_COSTING = 'job_costing',
  FINANCIAL_ORDER = 'financial_order',
  TRANSACTION_SUMMARY = 'transaction_summary',
}

export enum ReportViewEnum {
  WEEK = 'week',
  MONTH = 'month',
}

export enum PaymentStatusEnum {
  CHARGED = 'CHARGED',
}

export enum PaymentOrderStatusEnum {
  NOT_PAID = 'not paid',
  PAID = 'paid',
  PARTIALLY_PAID = 'partially paid',
}

export enum NoteTypeEnum {
  EXTERNAL = 'external',
  INTERNAL = 'internal',
  SITE = 'site',
}

export enum PermissionRoleEnum {
  LEAD = 'lead',
  CLIENT = 'client',
  JOB = 'job',
  TASK = 'task',
  SCHEDULE = 'schedule',
  QUOTE = 'quote',
  ORDER = 'order',
  INVOICE = 'invoice',
  PRODUCT = 'product',
  PACKAGE = 'package',
  QUARANTINE = 'quarantine',
  REPORT = 'report',
  TRUCK = 'truck',
  TRAILER = 'trailer',
  EQUIPMENT = 'equipment',
  VENDOR = 'vendor',
  PURCHASE = 'purchase',
  USER = 'user',
  ROLE = 'role',
  COUPON = 'coupon',
  EVENT_TYPE = 'eventType',
  CATEGORY = 'category',
  CHECKLIST = 'checklist',
}

export enum StatusInvoiceEnum {
  DRAFT = 'draft',
  PENDING = 'pending',
}

export enum MapDashboardStatus {
  DELIVERY = 'delivery',
  PICKUP = 'pickup',
  TRUCK = 'truck',
}

export enum DashboardTabTypeEnum {
  SALE = 'sale',
  OPERATION = 'operation',
}

export enum ChecklistTypeEnum {
  DEFAULT = 'default',
  PRODUCT = 'product',
  DAILY = 'daily',
  TASK = 'task',
}

export enum OrderListTypeEnum {
  FINALIZED = 'finalized',
  NOT_FINALIZED = 'not-finalized',
  CUSTOMER_PICKUPS = 'customer-pickups',
}

export enum OrderPickupEnum {
  DELIVERY_PICKUP = 'We Deliver & Pick-Up',
  CUSTOMER_PICKUPS = 'Customer Delivers & Picks-Up',
}

export enum PaymentAmountEnum {
  ORDER_BALANCE = 'Order Balance',
  DEPOSIT = 'Deposit',
  OTHER_AMOUNT = 'Other Amount',
}

export enum ScheduleSplitType {
  AVAILABLE_ORDERS = 'Available Orders',
  VEHICLE_SCHEDULE = 'Vehicle Schedule',
}

export enum PaymentTermsEnum {
  FULL_PREPAYMENT = 'full prepayment',
  NET_30 = 'net 30',
}

export enum ColorTypeEnum {
  RED = 'red',
  BLUE = 'blue',
  GREEN = 'green',
  YELLOW = 'yellow',
  PURPLE = 'purple',
}

export enum GroupByEnum {
  ORDER = 'order',
  QUOTE = 'quote',
  ALL = 'all',
  PRODUCT = 'product',
}

export enum DateTypeReportEnum {
  CANCELLATION = 'cancellation date',
  START_DATE = 'start date',
  CREATED_AT = 'created at',
  EVENT_DATE = 'event date',
  NEEDED_BY = 'needed by',
}

export enum MethodEnum {
  GET_DETAIL = 'get detail',
  UPDATE = 'update',
}
